"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const scroll_to_section_1 = require("./scroll-to-section");
const load_form_1 = require("./load-form");
const dom_utils_1 = require("../../utils/dom-utils");
const handleClick = (event) => {
    const target = event.target;
    if (target === null || target === void 0 ? void 0 : target.classList.contains('scrollAnimate')) {
        const href = target.getAttribute('href');
        if (href === null || href === void 0 ? void 0 : href.startsWith('#')) {
            (0, scroll_to_section_1.scrollToElementById)(href.substring(1));
            event.preventDefault();
        }
        else {
            console.error('Href attribute is not correctly specified.');
        }
    }
    else if (target === null || target === void 0 ? void 0 : target.classList.contains('formController')) {
        (0, load_form_1.switchForm)('form');
    }
};
if ((0, dom_utils_1.elementId)('scrollAnimate') || (0, dom_utils_1.queryAll)('.formController')) {
    document.addEventListener('click', handleClick);
}
;
